import React from "react";
import PropTypes from "prop-types";
import IconButton from "@shared/v2/IconButton";
import { Download, Trash } from "@shared/v2/Icomoon/Icons";

const DocumentRow = ({ document, onDelete }) => (
  <div className="tw-flex tw-items-center tw-gap-[8px] tw-py-[12px] hover:tw-bg-tinted-gray-25  tw-font-semibold">
    <div className="tw-basis-4/12 tw-text-12d">{document.naked_name}</div>
    <div className="tw-basis-1/12 tw-text-12d tw-flex tw-gap-[8px]">
      <i className={`fa ${document.image_icon} tw-text-theme-primary`} />
      <span>{document.file_type}</span>
    </div>
    <div className="tw-basis-1/12 tw-text-12d">{document.human_readable_size}</div>
    <div className="tw-basis-2/12 tw-text-12d">{document.added_ago}</div>
    <div className="tw-basis-3/12 tw-text-12d tw-flex tw-gap-[8px] tw-items-center">
      <div
        className="tw-flex-none !tw-w-[29px] !tw-h-[29px] tw-rounded-full tw-overflow-hidden [&>img]:tw-mb-0"
        dangerouslySetInnerHTML={{ __html: document.uploaded_by_image }}
      />
      <a href={document.uploaded_by_url} className="hover:tw-no-underline tw-text-12d">
        {document.uploaded_by_name}
      </a>
    </div>
    <div className="tw-basis-1/12 tw-flex tw-gap-[8px]">
      <IconButton
        size="small"
        schema="tertiary"
        onClick={() => {
          if (document.expiring_url) window.open(document.expiring_url, "_blank");
        }}
      >
        <Download />
      </IconButton>
      <IconButton size="small" schema="tertiary" onClick={() => onDelete(document.id)}>
        <Trash />
      </IconButton>
    </div>
  </div>
);

DocumentRow.propTypes = {
  document: PropTypes.shape().isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DocumentRow;
